import Vue from 'vue';
import Vuex from 'vuex';
import { parseRoles, hasAdminPortalAccess } from '../utils/roles';

Vue.use(Vuex);

const getStoredUser = () => {
  try {
    const raw = localStorage.getItem('user');
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
};

const getStoredToken = () => {
  return localStorage.getItem('authToken') || localStorage.getItem('token') || null;
};

export default new Vuex.Store({
  state: {
    authToken: getStoredToken(),
    tokenType: localStorage.getItem('tokenType') || 'Bearer',
    user: getStoredUser()
  },
  getters: {
    userRoles(state) {
      return parseRoles(state.user);
    },
    isSuperAdmin(state, getters) {
      return getters.userRoles.includes('superadmin');
    },
    isOwner(state, getters) {
      return getters.userRoles.includes('owner');
    },
    isMaker(state, getters) {
      return getters.userRoles.includes('maker');
    },
    hasAdminAccess(state) {
      return hasAdminPortalAccess(state.user);
    }
  },
  mutations: {
    setAuthToken(state, token) {
      state.authToken = token;
      if (token === null) {
        localStorage.removeItem('authToken');
        localStorage.removeItem('token');
      } else {
        localStorage.setItem('authToken', token);
        localStorage.setItem('token', token);
      }
    },
    login(state, token) {
      state.authToken = token;
      if (token === null) {
        localStorage.removeItem('authToken');
        localStorage.removeItem('token');
      } else {
        localStorage.setItem('authToken', token);
        localStorage.setItem('token', token);
      }
    },
    setTokenType(state, type) {
      state.tokenType = type;
      if (type === null) {
        localStorage.removeItem('tokenType');
      } else {
        localStorage.setItem('tokenType', type);
      }
    },
    setUser(state, user) {
      if (user === null) {
        state.user = null;
        localStorage.removeItem('user');
      } else {
        try {
          const userObj = typeof user === 'string' ? JSON.parse(user) : user;
          state.user = userObj;
          localStorage.setItem('user', JSON.stringify(userObj));
        } catch (e) {
          state.user = user;
          localStorage.setItem('user', JSON.stringify(user));
        }
      }
    }
  },
  actions: {
    updateAuthToken({ commit }, token) {
      commit('setAuthToken', token);
    },
    updateTokenType({ commit }, type) {
      commit('setTokenType', type);
    },
    updateUser({ commit }, user) {
      commit('setUser', user);
    }
  }
});